import { createSlice } from '@reduxjs/toolkit';

import { PortalModalDialogSliceState } from './store.types';

const initialPortalModalDialogSliceState: PortalModalDialogSliceState = {
  currentModal: null,
  modalActions: undefined
};

const portalModalDialogSlice = createSlice({
  name: 'portalModalDialogs',
  initialState: initialPortalModalDialogSliceState,
  reducers: {
    openModal: (state, action) => {
      state.currentModal = action.payload.currentModal;
      state.modalActions = action.payload.modalActions;
    },
    closeModal: (state) => {
      state.currentModal = null;
      state.modalActions = undefined;
    }
  }
});

export const { openModal, closeModal } = portalModalDialogSlice.actions;

export default portalModalDialogSlice.reducer;
